import React from 'react';
import { Box, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { usePauseSubscription } from 'hooks';

import { Button } from 'components/library';
import { Pause } from 'components/Icon';

import * as S from './styled';

import { IPausedSubscription } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';
import SubscriptionCardHeader from './SubscriptionCardHeader';
import PriceRow from './PriceRow';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';
import CancelSubscriptionBlock from './CancelSubscriptionBlock';

const PausedSubscription = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    onCancelSubscription,
    subscriptionType,
    isMainSubscription,
    isUpgrade,
    isOneTimeProduct,
    expirationDate,
    isPromoCodeUsed,
}: IPausedSubscription) => {
    const { t } = useTranslation();

    const { pauseToDate, onResumeSubscription } = usePauseSubscription();
    const isResumeAvailable = isMainSubscription && !isOneTimeProduct && !isPromoCodeUsed;

    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader Icon={tabIcon} heading={heading} />
            <S.GeneralInfo $mb={0}>
                <S.TextBox>
                    <Text color="text-secondary">
                        {t('subscription.cancellation.pausedSubscription.bannerText', { pauseToDate })}
                    </Text>
                </S.TextBox>
                <S.Status>
                    <Pause />
                    <Text type="caption" color="text-secondary">
                        {t('subscription.status.paused')}
                    </Text>
                    <Text type="caption" color="text-secondary">
                        :
                    </Text>
                </S.Status>
                <PriceRow price={price} period={subscriptionPeriod} subscriptionType={subscriptionType} />
                {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            </S.GeneralInfo>
            {isResumeAvailable && (
                <Box $paddingTop={20}>
                    <Button onClick={onResumeSubscription}>{t('subscription.text.resumeSubscription')}</Button>
                </Box>
            )}
            <CancelSubscriptionBlock
                isOneTimeProduct={isOneTimeProduct}
                date={expirationDate}
                onCancel={onCancelSubscription}
                paddingTop={10}
            />
        </SubscriptionCardWrapper>
    );
};

export default PausedSubscription;
